export default __webpack_public_path__ + "static/media/roll.0da23fa7.mp3";